<div class="d-flex flex-column p-2">

    <app-search-filter>
        <div class="row">
            <div class="col-4">
                <label for="symbol" class="form-label font-12">نماد:</label>
                <app-symbol-search [isMulti]="true" (selectSearchSymbol)="selected($event)"></app-symbol-search>
            </div>
            <div class=" col-2">
                <label for="traceNo" class="form-label font-12"> شماره گزارش:</label>
                <input type="input" class="form-control" id="traceNo" name="traceNo" [(ngModel)]="traceNo"
                    mask="000000000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-2">
                <label for="fiscalYear" class="form-label font-12">سال مالی:</label>
                <input type="input" class="form-control" id="fiscalYear" name="fiscalYear" [(ngModel)]="fiscalYear"
                    mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-2">
                <label for="reportMonth" class="form-label font-12"> ماه گزارش:</label>
                <input type="input" class="form-control" id="reportMonth" [(ngModel)]="reportMonth"
                    name="reportMonth" mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-2 d-flex align-items-end justify-content-end">
                <button class="btn btn-primary btn-sm" (click)="searchTable()">جستجو</button>
            </div>
        </div>
    </app-search-filter>
    <hr class="my-4" />
    <!-- Table content -->

    <app-table [data]="incomeStatementItems" [KeyName]="KeyName" [columnName]="columnName" [isLoading]="isLoading"
     [totalRecords]="totalRecords" [pageSize]="pageSize" [(page)]="page"
        (changePageEvent)="changePage($event)" (changeSizeEvent)="changeSize($event)"
        (expandRowEvent)="getDetailRow($event)" [isExpandable]="true" [children]="incomeStatementChildren" [columnNameChild]="columnNameChild"
        [KeyNameChild]="KeyNameChild" [isLoadingChild]="isLoadingChild"
        (sortEvent)="handleSort($event)"
        
        >
    </app-table>
</div>